<template>
<div class="row">
    <div class="large-5 columns"> <img src="/static/imgs/28719-640-transp.png" alt=""> </div>
    <div class="large-7 columns top">
        <div class="panel">
            <div class="panel-title">
                Confirmation de l'email
                <hr>
            </div>
            <div v-if="requestSent" class="panel-content">
                <spinner></spinner>
            </div>
            <div v-if="requestStatus === 200" class="panel-content">
                <div class="row columns">
                    <div class="large-12 columns">
                      <h2>Roule ma poule</h2>
                        <div>Votre adresse mail est validé</div>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="large-4 columns large-centered">
                        <router-link to="/home"><button class="full-width" type="submit">Aller à l'accueil</button></router-link>
                    </div>
                </div>
            </div>
            <div v-if="requestStatus != 200" class="panel-content">
                <div class="row columns">
                    <div class="large-12 columns">
                      <h2>oui, mais non</h2>
                        <div>la vérification de l'email n'a pas pu aboutir, merci de contactez un admin</div>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="large-4 columns large-centered">
                        <router-link to="/home"><button class="full-width" type="submit">Aller à l'accueil</button></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import auth from '../../api/auth.api'
import spinner from '../common/spinner.vue'
import store from '../../store/index.js'

export default {
  name: 'confirmEmail',
  components: {
    spinner
  },
  props: {
    'token': String
  },
  data () {
    return {
      requestSent: false,
      requestStatus: null
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
    this.requestSent = true
    console.log(this.token)
    this.requestSent = true
    auth.api.confirmEmail(this.token)
    .then(response => {
      this.requestSent = false
      this.requestStatus = response.status
    },
    error => {
      this.requestSent = false
      this.requestStatus = error.status
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-error {
  text-align: center;
  color: #CC0000;
}

.form-group {
  border-radius: 8px;
}

.notes {
  font-size: 0.7rem;
  font-weight: 300;
  color: #2F353B;
  text-align: left;
}

label {
  font-size: 1rem;
  color: #2F353B;
  font-weight: 500;
  text-align: left;
}

.is-danger {
  color:#E7505A;
}

.message {
  margin-top: 0.4rem;
  margin-left: 0rem;
  padding-left: 0rem;
  font-size: 0.9rem;
  text-align: left;
}

input.invalid{
  border-left: 3px solid #a94442;
}

input.valid{
  border-left: 3px solid #42A948; /* green */
}

input.untouched{
  border-left: 3px solid #ACB5C3;
}
</style>



// WEBPACK FOOTER //
// confirm-email.vue?3b890dfc